<!-- eslint-disable -->
<template>
  <div class="search-box popular-search">
    <h2 class="search-box-title">인기 검색어</h2>
    
    <!-- 로딩 상태 -->
    <div v-if="isLoading" class="loading-state">
      <div class="loading-spinner"></div>
      <span class="loading-text">인기 검색어를 불러오는 중...</span>
    </div>
    
    <!-- 인기 검색어 목록 -->
    <ol v-else class="search-list rank">
      <li 
        v-for="item in popularSearches" 
        :key="item.rank"
      >
        <a 
          href="#" 
          @click.prevent="handleSearchKeyword(item.keyword)"
          :aria-label="item.ariaLabel" :title="item.ariaLabel">
          {{ item.keyword }}
        </a>
      </li>
    </ol>

  </div>
</template>

<script>
import {PopularSearchService} from './services/popularSearchService';

export default {
  name: 'PopularSearches',
  
  props: {
    showSearchCount: {
      type: Boolean,
      default: false
    }
  },
  
  data() {
    return {
      popularSearches: [],
      isLoading: true
    };
  },
  
  
  async mounted() {
    // 초기 데이터 로드
    await this.loadPopularSearches();
  },
  
  methods: {
    async loadPopularSearches() {
      try {
        this.isLoading = true;
        this.popularSearches = await PopularSearchService.getPopularSearches('_ALL_', '');
      } catch (error) {
        this.popularSearches = [];
      } finally {
        this.isLoading = false;
      }
    },
    
    handleSearchKeyword(keyword) {
      this.$emit('search-keyword', keyword);
    }
  }
};
</script>



// WEBPACK FOOTER //
// PopularSearches.vue?2eca4626